export default __webpack_public_path__ + "static/media/Kel'Avashk Schenti.d1f31fbd.jpg";